import { Stack, Typography } from '@mui/material';
import React from 'react';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTheme } from '@emotion/react';
import { useState } from 'react';

export default function ChooseMeasurementValue({ unitType1, unitType2, onClickUp, onClickDown, selectedUnit }) {
  const theme = useTheme();

  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
    >
      <Typography
        className="fw-regular ff-Roboto fs-12"
        color={text}
      >
        {selectedUnit}
      </Typography>
      <Stack
        alignItems={'center'}
        justifyContent={'center'}
      >
        <ArrowDropUpIcon
          onClick={() => onClickUp()}
          style={{ cursor: 'pointer', color: selectedUnit === unitType1 ? '#8993AC' : '#8993AC59',}}
        />

        <ArrowDropDownIcon
          onClick={() => onClickDown()}
          style={{ cursor: 'pointer', color: selectedUnit === unitType2 ? '#8993AC' : '#8993AC59', marginTop:'-10px' }}
        />
      </Stack>
    </Stack>
  );
}
